module.exports = __webpack_public_path__ + "static/media/ImgMBTI_RPTC.277a2eec.png";